module.exports = __webpack_public_path__ + "img/menu-icon-6-2.7fb8948a.svg";